import { render } from "./top_menu.vue?vue&type=template&id=f97a350c"
import script from "./top_menu.vue?vue&type=script&lang=js"
export * from "./top_menu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/willson/Desktop/project/welove/admin_js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__